import { getRouteApi, Link } from '@tanstack/react-router'
import { useMatches } from '@tanstack/react-router'

import { RbWizardLogo } from '@/assets/icons'

const routeApi = getRouteApi('/_auth')
export const HeaderAuth = () => {
  const matches = useMatches()
  const { type } = routeApi.useSearch()
  const isCodeVerification = matches.some((m) => m.routeId === '/_auth/login/verify-email/code')

  if (isCodeVerification) {
    return null
  }

  return (
    <header className="rounded-md">
      <div className="flex items-center justify-between gap-4">
        {type !== 'oauth' && (
          <Link
            aria-label="Go to Rakeback Wizard Home Page"
            style={{ display: 'flex', alignItems: 'center' }}
            to="/"
          >
            <RbWizardLogo width={120} />
          </Link>
        )}
      </div>
    </header>
  )
}
